module.exports = __webpack_public_path__ + "static/bannerPricing-dbd28567ba126bf283c8676229bbbaaa.png";